import { useBusinessContext } from '@root/context'
import { IBusinessOnboardStep } from '@query'
import { useMemo } from 'react'

const ADD_FILE_STEP = 'add_file'
const ADD_FOLDER_STEP = 'add_folder'

const hasOpenChildStep = (steps: IBusinessOnboardStep[], childStep: string): boolean =>
  steps.some(group =>
    group.child_steps.some(
      child =>
        child.step === childStep && child.completed_at === null && child.dismissed_at === null
    )
  )

export const useOnboardSteps = () => {
  const { data: business } = useBusinessContext()

  const onboardSteps = business?.onboard_steps ?? []

  const hasFinished = useMemo(() => {
    if (!onboardSteps.length) return false

    return onboardSteps.every(step =>
      step.child_steps.every(child => child.completed_at !== null || child.dismissed_at !== null)
    )
  }, [onboardSteps])

  const hasOpenAddFileStep = useMemo(
    () => hasOpenChildStep(onboardSteps, ADD_FILE_STEP),
    [onboardSteps]
  )
  const hasOpenAddFolderStep = useMemo(
    () => hasOpenChildStep(onboardSteps, ADD_FOLDER_STEP),
    [onboardSteps]
  )

  const hasSteps = onboardSteps.length > 0

  return { hasFinished, hasSteps, hasOpenAddFileStep, hasOpenAddFolderStep }
}
